export const NAVIGATION_TABS = [
  { name: 'challenges', title: 'By Challenge' },
  { name: 'years', title: 'By Year' },
  { name: 'subsectors', title: 'By Subsector' },
  { name: 'countries', title: 'By Country' },
] as const

export type NavigationTabName = typeof NAVIGATION_TABS[number]['name']

export const NOT_AVAILABLE = { label: 'No data for this country', color: '#c5ced7' }

export const SHORT_COUNTRY_NAMES = {
  'United States of America': 'USA',
  'Russian Federation': 'Russian Fed.',
}
